import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNavSection() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-6 md:mb-8">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
          漫画分类
        </h2>
        <p className="text-sm text-foreground-500 mt-1">找到你最喜欢的漫画类型</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-2xl bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
              <i className={`${cat.icon} text-xl md:text-2xl`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
              {cat.name}
            </span>
            <span className="text-xs text-foreground-400">{cat.count}部</span>
          </Link>
        ))}
      </div>
    </section>
  );
}